import { useIsMobile, usePaginationQueryParam } from 'noddi-ui-web';

// Normally we init for mobile 10 default page size, but for customer app we want 5/10 as we have card layouts instead of table
export const useCustomerAppPagination = () => {
  const isMobile = useIsMobile();

  const defaultPageSize = isMobile ? 3 : 5;

  return usePaginationQueryParam({
    initialPageSize: defaultPageSize
  });
};
